module.exports = __webpack_public_path__ + "assets/img/18406055aef2cefcfd41ce6fe04d10ac.png";